/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     商城模块api
  +--------------------------------------------------------------------------------------
*/
import request from "@/utils/request";
const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST
export function getProductCategoryApi() {
  return request({
    url: "?c=shop&a=product-category&do=getall",
    method: "get"
  });
}

export function getGodProductCategoryApi() {
  return request({
    url: "?c=shop&a=god-category&do=getall",
    method: "get"
  });
}

export function getfewCategoryApi(data) {
  return request({
    url: "?c=shop&a=product-category&do=getfew",
    method: "post",
    data
  });
}

export function getCategoryDetailApi(data) {
  return request({
    url: "?c=shop&a=product-category&do=get",
    method: "post",
    data
  });
}

export function postProductApi(data) {
  return request({
    url: "?c=shop&a=product&do=post",
    method: "post",
    data
  });
}

export function getMallProductListApi(params) {
  return request({
    url: "?c=shop&a=product&do=list",
    method: "get",
    params
  });
}

export function getProductDetailApi(params) {
  return request({
    url: "?c=shop&a=product&do=get",
    method: "get",
    params
  });
}

// export function getProductOrderListApi(params) {
//   return request({
//     url: "?c=shop&a=order&do=list",

//     method: "get",
//     params
//   });
// }

export function getProductOrderListApi(params) {
  return request({
    // url: "?c=shop&a=order&do=list",
    url: `${jsApiHost}/ei/order/incomelist`,
    method: "get",
    params
  });
}

export function eiOrderDeatilApi(params) {
  return request({
    url: `${jsApiHost}/ei/order/get`,
    method: "get",
    params
  });
}

export function getProductOrderDetailApi(params) {
  return request({
    url: "?c=shop&a=order&do=get",
    method: "get",
    params
  });
}

export function putOnShelfApi(data) {
  return request({
    url: "?c=shop&a=product&do=put",
    method: "post",
    data
  });
}

export function putOffShelfApi(data) {
  return request({
    url: "?c=shop&a=product&do=off",
    method: "post",
    data
  });
}

export function delProductApi(data) {
  return request({
    url: "?c=shop&a=product&do=delete",
    method: "post",
    data
  });
}

export function resetProductReviewApi(data) {
  return request({
    url: "?c=shop&a=product&do=audit-callback",
    method: "post",
    data
  });
}

export function getDeliveryApi(params) {
  return request({
    url: "?c=shop&a=delivery&do=getall",
    method: "get",
    params
  });
}

export function shipProductAPi(data) {
  return request({
    url: "?c=shop&a=order&do=shipping",
    method: "post",
    data
  });
}

export function stickProductAPi(data) {
  return request({
    url: `${ jsApiHost }/ei/product/stick`,
    method: "post",
    data
  });
}

export function unstickProductAPi(data) {
  return request({
    url: `${ jsApiHost }/ei/product/unstick`,
    method: "post",
    data
  });
}

export function preUpload(params) {
  return request({
    url: `${ jsApiHost }/utility/file/preUploadAes`,
    method: "get",
    params
  });
}

export function finishUpload(data) {
  return request({
    url: `${ jsApiHost }/utility/file/finishUpload`,
    method: "post",
    data
  });
}